define(['moduler'], function (Moduler) {
    'use strict';

    return Moduler.create({
        defaults: {
            event: null,
            url: null,
            data: null, // extra data to send along the request to server
            headers: null,
            method: 'GET',
            contentElement: null,
            loadOnInit: false,
            insertMode: 'replace', // modes: [null|replace|append]. 
            loadingCssClass: 'is-loading',
            formPoster: false,
            submitButton: 'input[type=submit], button[type=submit]',
            selfPoster: false // if formPoster not set send element data
        },

        init: function () {
            var self = this;

            self.contentElement = document.querySelector(self.options.contentElement) ?? self.el;

            if (self.options.formPoster) {
                self.form = self.el.matches('form') ? self.el : self.el.querySelector('form');
                self.submitButton = self.form.querySelector(self.options.submitButton);

                // set override options for formPoster
                self.options.event = 'submit';
                self.options.url = self.options.url || self.form.getAttribute('action');
                self.options.method = self.form.getAttribute('method') || self.options.method;

                // dont submit the actual form when acting as a form poster
                self.form.addEventListener('submit', function (e) {
                    e.preventDefault();
                });
            }

            if (self.options.event) {
                self.el.addEventListener(self.options.event, Moduler.utils.bind(self.sendRequest, self));
            }

            if (self.options.loadOnInit) {
                self.sendRequest();
            }
        },

        sendRequest: function (insertMode) {
            var self = this;

            self.isLoading = true;

            self.el.classList.add(self.options.loadingCssClass);

            var formData = new FormData();
            if (self.options.formPoster) {
                formData = new FormData(self.form);
            } else if (self.options.selfPoster) {
                formData.append(self.el.name, self.el.value);
            }

            if (self.options.data) {
                var customData = {};
                Object.assign(customData, self.options.data);
                for (var key in customData) {
                    formData.append(key, customData[key]);
                }
            }

            var opts = {
                method: self.options.method,
                body: formData
            };

            if (self.options.headers != null) {
                opts.headers = self.options.headers
            }

            var url = self.options.url;

            // send all as query params in get reuqests and skip the body, the body property is only for post requests
            if (self.options.method.toLowerCase() == 'get') {
                url = url + (url.indexOf('?') > -1 ? '&' : '?') + new URLSearchParams(formData).toString();
                opts = {
                    method: self.options.method
                };
            }

            return fetch(url, opts).then(response => {
                self.isLoading = false;
                self.el.classList.remove(self.options.loadingCssClass);
                self.el.dispatchEvent(new CustomEvent('ajax-always'));
                if (response.status != 200) {
                    self.el.dispatchEvent(new CustomEvent('ajax-error'));
                } else {
                    response.text().then(function (text) {
                        if (response.headers.has('content-type') && response.headers.get('content-type').indexOf('text/html') !== -1) {
                            if (self.options.insertMode === 'replace') {
                                self.contentElement.innerHTML = text;
                            } else if (self.options.insertMode === 'append') {
                                self.contentElement.innerHTML += text;
                            }
                            Moduler.loadModules(self.contentElement);
                        }
                        self.el.dispatchEvent(new CustomEvent('ajax-done', { response: text }));
                    });
                }
            });
        }
    });
});